import { getLoginPath } from "~/composables/auth-redirect";

export default defineNuxtRouteMiddleware(async (to) => {
  const client = useClient();

  if (!client.isAuthenticated) {
    await client.refreshToken(true);

    if (!client.isAuthenticated) {
      return navigateTo(getLoginPath(to.fullPath));
    }
  }
});
